import React from 'react';
import CoverPanel from './CoverPanel';
import CurrentWorldType from './CurrentWorldType';

const WorldsSpaceportColumn = ({
  currentWorld,
  currentWorldType,
  onBrowse,
  onNewWorldClick,
  onWorldClick,
  worldType,
  worlds,
}) => {
  const shouldShowCoverPanel = currentWorldType !== worldType;

  if (shouldShowCoverPanel) {
    return (
      <CoverPanel
        onBrowse={() => onBrowse(worldType)}
        onNewWorldClick={onNewWorldClick}
        worldType={worldType}
      />
    );
  }

  return (
    <CurrentWorldType
      currentWorld={currentWorld}
      onNewWorldClick={onNewWorldClick}
      onWorldClick={onWorldClick}
      worldType={worldType}
      worlds={worlds}
    />
  );
};

export default WorldsSpaceportColumn;
